// extracted by mini-css-extract-plugin
export default {"employeeSurnameFirstLetterGroups":"EmployeeSurnameFilter_employeeSurnameFirstLetterGroups__zs2cS"};